import { render, staticRenderFns } from "./BeneficiaryInformation.vue?vue&type=template&id=4d7471d9"
import script from "./BeneficiaryInformation.vue?vue&type=script&lang=js"
export * from "./BeneficiaryInformation.vue?vue&type=script&lang=js"
import style0 from "./BeneficiaryInformation.vue?vue&type=style&index=0&id=4d7471d9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports